export default __webpack_public_path__ + "458810528bbffd19070f29e8e17f938a.svg";